const expandableItem = () => {
	let expandableItems = document.querySelectorAll(".expandableItemJs");

	if (!expandableItems.length) return;

	const getHeightVisible = (element) => {
		const mobileBreakpoint = 480;
		const tabletBreakpoint = 768;

		if (window.innerWidth <= mobileBreakpoint) {
			return element.getAttribute("data-expand-mobile");
		} else if (window.innerWidth <= tabletBreakpoint) {
			return element.getAttribute("data-expand-tablet");
		} else {
			return element.getAttribute("data-expand-desktop");
		}
	};

	expandableItems.forEach((item) => {
		const realHeight = item.offsetHeight;
		const heightVisible = getHeightVisible(item);
		let buttonExpand = null;
		if (realHeight >= heightVisible) {
			item.style.height = heightVisible + "px";

			item.classList.add("expandableItemJs--hide");

			// creation of the button
			// Création du bouton d'expansion
			buttonExpand = document.createElement("button");
			buttonExpand.classList.add("expandableItemJs__button");
			buttonExpand.innerHTML =
				"<span><i class='icon-chevron-down'></i></span>";
			item.appendChild(buttonExpand);
			//-----
		} else {
			item.style.height = realHeight + "px";
		}

		if (!buttonExpand) return;
		buttonExpand.addEventListener("click", () => {
			const isExpanded = buttonExpand.classList.contains("expanded");

			if (isExpanded) {
				item.classList.add("expandableItemJs--hide");

				item.style.height = heightVisible + "px";

				buttonExpand.classList.remove("expanded");
				buttonExpand.innerHTML =
					"<span><i class='icon-chevron-down'></i></span>";

				// Défilement fluide vers l'élément
				window.scrollTo({
					top:
						item.offsetTop +
						(parseInt(heightVisible) - window.innerHeight / 1.5),
					left: 0,
					behavior: "smooth",
				});
			} else {
				item.classList.remove("expandableItemJs--hide");
				item.style.height = realHeight + "px";
				buttonExpand.classList.add("expanded");
				buttonExpand.innerHTML =
					"<span><i class='icon-chevron-up'></i></span>";
			}
		});
	});
};
export default expandableItem;
